module.exports = __webpack_public_path__ + "static/media/ic-manage.5a4e3a39.svg";